import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { Yii } from "libraries/interfaces/Yii";

export const actionTypeOptions: IMultiselectOptions[] =  [
    {
        value: 'issue',
        label: Yii.t('wui-shared-js', 'Émission')
    },
    {
        value: 'void',
        label: Yii.t('wui-shared-js', 'Annulation')
    },
    {
        value: 'systemVoid',
        label: Yii.t('wui-shared-js', 'Annulation auto')
    },
    {
        value: 'exchange',
        label: Yii.t('wui-shared-js', 'Échange')
    },
    {
        value: 'refund',
        label: Yii.t('wui-shared-js', 'Remboursement')
    },
];
